

function hasTranscodedVideoFiles(asset) {
  const { assetFiles, metaData } = asset || {};

  const metaDataObj = metaData && JSON.parse(metaData);

  const { type = '' } = metaDataObj || {};

  if (type.includes('audio/')) {return Boolean(assetFiles && assetFiles.ORIGINAL);}

  return Boolean(assetFiles && (assetFiles.HD || assetFiles.SD));
}

export default hasTranscodedVideoFiles;